import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store';

import { authSliceName } from './index';

export const authSelector = (state: RootState): RootState[typeof authSliceName] => state[authSliceName];

export const loggedInSelector = createSelector(authSelector, (authSlice) => authSlice.loggedIn);

export const loginStateSelector = createSelector(authSelector, (authSlice) => authSlice.login);

export const signUpStateSelector = createSelector(authSelector, (authSlice) => authSlice.signUp);

export const explicitLogoutSelector = createSelector(authSelector, (authSlice) => authSlice.explicitLogout);
